import { useState } from "react";
import { useDispatch } from "react-redux";
import { saveUnSaveBlog } from "../../features/blog/BlogSlice";

export default function SaveUnSave({ id, isSaved }) {
	const dispatch = useDispatch();

	const [isBlogSaved, setIsBlogSaved] = useState(isSaved);
	const handleBlogSaved = () => {
		dispatch(saveUnSaveBlog({ id, isSaved: !isBlogSaved })).then(
			setIsBlogSaved(!isBlogSaved)
		);
	};

	return (
		<button
			onClick={handleBlogSaved}
			className={`${isBlogSaved && "active"} save-btn`}
			id="lws-singleSavedBtn"
		>
			<i className="fa-regular fa-bookmark"></i>{" "}
			{isBlogSaved ? "Saved" : "Save"}
		</button>
	);
}
